<template>
    <div>
        <div class="row mx-auto my-2 mt-5">
            <div class="col-md-3">
                <template>
                    <v-card
                            :loading="loading"
                            flat
                            class="mx-auto position-relative mb-12"
                            max-width="374"
                            style="border-radius: 15px"
                    >
                        <template v-slot:loader="{ isActive }">
                            <v-progress-linear
                                    :active="isActive"
                                    color="deep-purple"
                                    height="4"
                                    indeterminate
                            ></v-progress-linear>
                        </template>

                        <v-img
                                cover
                                height="100"
                                src="https://www.zarinexpress.com/static/media/banner_default.ee83f5325b060948cd5e.png"
                        ></v-img>
                        <div class="position-absolute" style="top:5rem;left:1rem">
                            <v-avatar
                                    color="grey"
                                    size="80"
                                    rounded="5"
                            >
                                <v-img cover
                                       src="https://www.zarinexpress.com/static/media/shop_logo_default.440eadd27d0657202ef5.png"></v-img>
                            </v-avatar>
                        </div>

                        <v-card-title class="font-weight-bold">فروشگاه من</v-card-title>

                        <v-card-subtitle>
                            <a class="me-1" href="https://www.zarinexpress.com">www.zarinexpress.com</a>
                        </v-card-subtitle>

                        <v-card-text class="text-center">
                            <v-row class="mx-auto text-center">
                                <v-icon
                                        v-for="item in socialMedia"
                                        :color="item.color"
                                        style="font-size: 20px"
                                >{{ item.icon }}
                                </v-icon>
                            </v-row>
                        </v-card-text>

                        <v-expand-transition>
                            <div v-show="show">
                                <v-divider></v-divider>
                                <div class="col-md-12 my-2 mx-0">Small plates, salads & sandwiches - an intimate setting
                                    with 12 indoor seats plus patio seating.
                                </div>

                                <v-card-title>Tonight's availability</v-card-title>

                                <div class="px-4">
                                    <v-chip-group v-model="selection">
                                        <v-chip>5:30PM</v-chip>

                                        <v-chip>7:30PM</v-chip>

                                        <v-chip>8:00PM</v-chip>

                                        <v-chip>9:00PM</v-chip>
                                    </v-chip-group>
                                </div>
                            </div>
                        </v-expand-transition>


                        <v-card-actions>
                            <v-btn
                                    @click="show = !show"
                                    icon
                            >
                                <i color="indigo"
                                   :class="show ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"
                                ></i>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                    <v-card class="my-4 px-3 pb-2 font-weight-bold" style="border-radius: 15px">
                        <div @click="getActive(item.name)" class="row pt-4" v-for="item in menu" :style="{'color':`${item.color}`}">
                            <icon-list :color="item.color" :name="item.iconName"></icon-list>
                            <p>{{ item.name }}</p>
                            <hr>
                        </div>
                    </v-card>
                </template>
            </div>
            <div class="col-md">
                <v-card flat style="border-radius: 15px;background-color: #f9f9f9">
                    <v-card-title class="font-weight-bold">سفارشات</v-card-title>
                    <div class="row mx-auto">
                        <div class="col-md-4" v-for="item in orderList">
                            <template>
                                <v-card
                                        class="mx-auto"
                                        style="border-radius: 15px"
                                        max-width="344"
                                >
                                    <v-card-text class="text-center">
                                        <v-icon large>mdi-history</v-icon>
                                        <h6 class="text--primary text-center mt-4">
                                            <span>{{ persianNum(item.count) }}</span>
                                            سفارش
                                        </h6>
                                        <p>{{ item.category }}</p>
                                    </v-card-text>
                                </v-card>
                            </template>
                        </div>
                    </div>
                </v-card>
                <v-card flat class="my-4 mt-10" style="border-radius: 15px;background-color: #f9f9f9">
                    <v-card-title class="font-weight-bold">محصولات</v-card-title>
                    <div class="row mx-auto">
                        <div class="col-md-4" v-for="item in productList">
                            <template>
                                <v-card
                                        class="mx-auto"
                                        style="border-radius: 15px"
                                        max-width="344"
                                >
                                    <v-card-text class="text-center">
                                        <v-icon v-if="item.category!=='ناموجود'" color="success" large>mdi-check
                                        </v-icon>
                                        <v-icon v-if="item.category==='ناموجود'" color="red" large>mdi-close</v-icon>
                                        <h6 class="text--primary text-center mt-4">
                                            <span>{{ persianNum(item.count) }}</span>
                                            سفارش
                                        </h6>
                                        <p>{{ item.category }}</p>
                                    </v-card-text>
                                </v-card>
                            </template>
                        </div>
                    </div>
                </v-card>
            </div>

        </div>
    </div>
</template>

<script>
import IconList from "./icon";
export default {
    name: "index",
    components: {IconList},
    data: () => ({
        loading: false,
        selection: 1,
        show: false,
        socialMedia: [
            {color: 'blue', icon: 'mdi-telegram', link: ''},
            {color: 'pink', icon: 'mdi-instagram', link: ''},
            {color: 'indigo', icon: 'mdi-facebook', link: ''},
            {color: 'black', icon: 'mdi-linkedin', link: ''},
        ],
        orderList: [
            {count: '0', icon: '', category: 'در انتظار تایید'},
            {count: '0', icon: '', category: 'در حال آماده سازی'},
            {count: '0', icon: '', category: 'آخرین روز ارسال'},
        ],
        productList: [
            {count: '0', icon: '', category: 'منتشر شده'},
            {count: '0', icon: '', category: 'رو به اتمام'},
            {count: '0', icon: '', category: 'ناموجود'},
        ],
        menu: [
            {color: 'darkBlue', iconName: 'list', name: 'پیشخوان'},
            {color: 'grey', iconName: 'product', name: 'محصولات'},
            {color: 'grey', iconName: 'category', name: 'دسته بندی'},
            {color: 'grey', iconName: 'sendWay', name: 'روش و هزینه ارسال'},
            {color: 'grey', iconName: 'ticket', name: 'تیکت ها'},
            {color: 'grey', iconName: 'comment', name: 'نظرات'},
        ],
    }),

    methods: {
        reserve() {
            this.loading = true
            setTimeout(() => (this.loading = false), 2000)
        },
        getActive(name){
            this.menu.find((x)=>x.name===name).color='darkBlue'
        }
    },
}
</script>

<style scoped>

</style>